var swiper = new Swiper('.product-grid-carousel .pgc-swiper', {
    spaceBetween: 11,
    slidesPerView: 1.80,
    grabCursor: true,
    keyboard: true,
    navigation: {
        nextEl: '.product-grid-carousel .swiper-button-next',
        prevEl: '.product-grid-carousel .swiper-button-prev',
    },
    breakpoints: {
        750: {
            spaceBetween: 15,
            slidesPerView: 2
        },
        1024: {
            spaceBetween: 20,
            slidesPerView: 2.5
        },
        1280: {
            spaceBetween: 28,
            slidesPerView: 3
        },
        1600: {
            spaceBetween: 32,
            slidesPerView: 4
        }
    }
});